export const PAGE_SIZE = 15;
export const ORDER_DIRECTION = ['desc', 'asc', ''];
export default {
  PAGE_SIZE,
  ORDER_DIRECTION,
};
